// material-ui
import { useTheme } from '@mui/material/styles';
import { ThemeMode } from 'config';
// import logoIcon3 from 'assets/images/logo3.png';
import logoIcon from 'assets/images/menuMinimize.png';


// This is the menu logo

// ==============================|| LOGO ICON SVG ||============================== //

const LogoIcon = () => {
  const theme = useTheme();

  return (
   
    <img src={theme.palette.mode === ThemeMode.DARK ? logoIcon : logoIcon} alt="icon logo" width="30" />
  );
};

export default LogoIcon;
